module.exports = __webpack_public_path__ + "static/media/logoMercantil.5e3d5767.png";